import { CellAction } from "./cell-action";

import { Gallerie } from "@/src/data/types";
import { ColumnDef } from "@tanstack/react-table";

export const columns: ColumnDef<Gallerie>[] = [
  {
    accessorKey: "title",
    header: "TITRE",
  },
  {
    accessorKey: "category",
    header: "CATÉGORIE",
  },
  {
    accessorKey: "subCategory",
    header: "SOUS CATÉGORIE",
  },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
